import { Api } from '@/services/Api';

export default {
    /*  1. Get all data */
    getBeneficiaryInformationManagements(body = { keyword: '' }) {
        return Api().post('/BeneficiaryInformationManagement/GetBeneficiaryInformationManagementByCriteria', body);
    },
    getAllBeneficiaryInformationManagements(body = { keyword: '' }) {
        return Api().post('/BeneficiaryInformationManagement/GetAllBeneficiaryInformationByCriteria', body);
    },
    /*  2. Get one column */

    getBeneficiaryInformationManagement(id) {
        return Api().get(`/BeneficiaryInformationManagement/${id}`);
    },
    /*  3. Create one column */
    saveFullBeneficiaryInformationManagement(body) {
        return Api().post(`/BeneficiaryInformationManagement/SaveInformation`, body);
    },
    saveBeneficiaryInformationManagement(body) {
        return Api().post(`/BeneficiaryInformationManagement`, body);
    },
    SaveAidInformation(body) {
        return Api().post(`/BeneficiaryInformationManagement/SaveAidInformation`, body);
    },
    /*  4. Delete one or more columns */
    deleteBeneficiaryInformationManagements(body) {
        return Api().post(`/BeneficiaryInformationManagement/DeleteBeneficiaryInformationManagement`, body);
    },
    /*  5. post one or more columns */
    postBeneficiaryInformationManagements(body) {
        return Api().post(`/BeneficiaryInformationManagement/PostBeneficiaryInformationManagement`, body);
    },
    startWF(body) {
        return Api().post(`/BeneficiaryInformationManagement/StartWF`, body);
    },

    GetCSPDNameBYNationalNum(NationalNum) {
        return Api().get(`/BeneficiaryInformationManagement/GetCSPDNameBYNationalNum?NationalNum=${NationalNum}`);
    },
    GetCSPDInfoBYNationalNum(NationalNum, cardidno,bod) {
        return Api().get(`/BeneficiaryInformationManagement/GetCSPDInfoBYNationalNum?NationalNum=${NationalNum}&cardno=${cardidno}&bod=${bod}`); 
    },
};
